export enum UserEvents {
  VISIT_SUBMITTED = 'VISIT_SUBMITTED',
  VISIT_UPDATED = 'VISIT_UPDATED',
  VISIT_CANCELED = 'VISIT_CANCELED',
  VISIT_ERROR_IMPRESSION = 'VISIT_ERROR_IMPRESSION',
  VISITOR_REGISTRATION_INITIALIZED = 'VISITOR_REGISTRATION_INITIALIZED',
  ADD_VISITOR_CLICK = 'ADD_VISITOR_CLICK',
  PAST_VISIT_CLICK = 'PAST_VISIT_CLICK',
}
